module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ahead3-c2e0422ddb8bbe6a7181c5cae6870bc9.jpg";